import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
import { EmptyState } from './EmptyState.js';
import { Spinner } from './Spinner.js';
const densityClasses = {
    compact: 'px-3 py-1.5 text-[13px]',
    normal: 'px-4 py-2.5 text-sm',
    comfortable: 'px-5 py-3.5 text-sm',
};
const alignClasses = {
    left: 'text-left',
    right: 'text-right',
    center: 'text-center',
};
export function DataTable({ columns, data, rowKey, loading, emptyTitle = 'Nada por aqui ainda', emptyDescription, emptyAction, onRowClick, density = 'normal', className, }) {
    if (loading) {
        return (_jsx("div", { className: "flex items-center justify-center py-16", children: _jsx(Spinner, { size: "lg", variant: "aurora" }) }));
    }
    if (data.length === 0) {
        return (_jsx(EmptyState, { title: emptyTitle, description: emptyDescription, action: emptyAction }));
    }
    const cellPadding = densityClasses[density];
    return (_jsx("div", { className: cn('overflow-x-auto rounded-ax-lg border border-ax-line bg-ax-graphite', className), children: _jsxs("table", { className: "w-full border-collapse", children: [_jsx("thead", { children: _jsx("tr", { className: "border-b border-ax-line bg-ax-night/40", children: columns.map((col) => (_jsx("th", { style: col.width ? { width: col.width } : undefined, className: cn('ax-eyebrow text-ax-text-tertiary font-medium', cellPadding, alignClasses[col.align ?? 'left'], col.hiddenOnCompact && density === 'compact' && 'hidden'), children: col.header }, col.key))) }) }), _jsx("tbody", { children: data.map((row, idx) => (_jsx("tr", { onClick: onRowClick ? () => onRowClick(row) : undefined, className: cn('border-b border-ax-line last:border-b-0', 'transition-colors duration-ax-fast', onRowClick && 'cursor-pointer hover:bg-ax-night/60'), children: columns.map((col) => {
                            const value = col.render
                                ? col.render(row, idx)
                                : row[col.key];
                            return (_jsx("td", { className: cn('text-ax-text-primary', cellPadding, alignClasses[col.align ?? 'left'], col.mono && 'font-mono text-[12px]', col.hiddenOnCompact && density === 'compact' && 'hidden'), children: value }, col.key));
                        }) }, rowKey(row, idx)))) })] }) }));
}
//# sourceMappingURL=DataTable.js.map